import type { ApiResponse, CallerType } from '@klaro7/shared-types';
import api from '@/lib/api';

export interface AnswerCallInfo {
  callSessionId: string;
  callType: 'audio' | 'video' | 'chat';
  callerId: string;
  callerName: string;
  callerAvatar?: string;
  callerDateOfBirth?: string;
  costPerMinute: number;
  callerType: CallerType;
  conversationId?: string;
}

export async function getAnswerByToken(token: string): Promise<AnswerCallInfo> {
  const res = await api.get<ApiResponse<AnswerCallInfo>>(`/calls/answer/${token}`);
  return res.data.data;
}
